import { FC, PropsWithChildren, ReactNode } from "react";

type ConditionalWrapperProps = {
  condition: boolean;
  truthfulWrapper: (children: ReactNode) => ReactNode;
  untruthfulWrapper?: (children: ReactNode) => ReactNode;
};

const ConditionalWrapper: FC<PropsWithChildren<ConditionalWrapperProps>> = ({
  condition,
  truthfulWrapper,
  untruthfulWrapper,
  children,
}) => {
  return (
    <>
      {condition
        ? truthfulWrapper(children)
        : untruthfulWrapper
        ? untruthfulWrapper(children)
        : children}
    </>
  );
};

export default ConditionalWrapper;
